// Info: Import NPM Dependancies
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const FeedBackSlice = createSlice({
  name:'feedback',
  initialState:{
    isMessageLoaded: false,
    feedbackData:{
      
      userId:"",
      questions:[
        {
          questionId:"",
          question:"",
        }
      ]
    }
  },
  reducers:{
    setIsMessageLoaded: (state, action: {payload: boolean}) => {
      return {
        ...state,
        isMessageLoaded: action.payload
      }
    },
    setQuestion:(state,action)=>{
      let index=state.feedbackData.questions.findIndex((question)=> question.questionId == action.payload.questionId)
      if(index<0){
        state.feedbackData.questions=[...state.feedbackData.questions,action.payload]
      }
      
    }
  }
})
export const {setQuestion, setIsMessageLoaded}=FeedBackSlice.actions;

export const getIsMessageLoaded = (state: RootState) => state.feedback.isMessageLoaded
export default FeedBackSlice.reducer;
